export default __webpack_public_path__ + "static/media/carousel-2.0561cfa6.jpg";